var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_menu",
    transform: "translate(-0.488 0.033)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1123",
    "data-name": "Rectangle 1123",
    width: 24,
    height: 24,
    transform: "translate(0.488 -0.033)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M-8207.8-1564.533v-1.5h11.286v1.5Zm-4.716,0v-1.5h3v1.5Zm4.716-6v-1.5h11.286v1.5Zm-4.716,0v-1.5h3v1.5Zm4.716-6v-1.5h11.286v1.5Zm-4.716,0v-1.5h3v1.5Z",
    transform: "translate(8216 1582.999)",
    fill: "#6db3e0"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLists);
export default __webpack_public_path__ + "static/media/lists.5c675998eccec34015dd9c6f9b706ab1.svg";
export { ForwardRef as ReactComponent };